
export function position() {
    var target = document.querySelector('.footer__box');
    var content = document.querySelector('.footer__seo-lists');
    target.appendChild(content);
}
